import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'ro',
  months: [
    'ianuarie',
    'februarie',
    'martie',
    'aprilie',
    'mai',
    'iunie',
    'iulie',
    'august',
    'septembrie',
    'octombrie',
    'noiembrie',
    'decembrie',
  ],
  monthsShort: ['ian', 'feb', 'mar', 'apr', 'mai', 'iun', 'iul', 'aug', 'sep', 'oct', 'noi', 'dec'],
  weekdays: ['Duminică', 'Luni', 'Marți', 'Miercuri', 'Joi', 'Vineri', 'Sâmbătă'],
  weekdaysMin: ['Du', 'Lu', 'Ma', 'Mi', 'Jo', 'Vi', 'Sâ'],
  weekdaysShort: ['Dum', 'Lu', 'Ma', 'Mi', 'Joi', 'Vi', 'Sâm'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'HH:mm',
    lts: 'HH:mm:ss',
    L: 'DD.MM.YYYY',
    LL: 'D MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM YYYY HH:mm',
    'LLL-Y': 'D MMMM HH:mm',
    LLLL: 'dddd, D MMMM YYYY HH:mm',
    'LLLL-Y': 'dddd, D MMMM HH:mm',
    l: 'D.M.YYYY',
    'l-Y': 'D.M',
    ll: 'D MMM YYYY',
    'll-Y': 'D MMM',
    lll: 'D MMM YYYY HH:mm',
    'lll-Y': 'D MMM HH:mm',
    llll: 'ddd, D MMM YYYY HH:mm',
    'llll-Y': 'ddd, D MMM HH:mm',
    'll-Y+w': 'ddd, D MMM',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'D MMMM YYYY, HH:mm ([GMT]Z)',
  },
  past: {
    y: { one: 'acum %s an', few: 'acum %s ani', other: 'acum %s de ani' },
    M: { one: 'acum %s lună', few: 'acum %s luni', other: 'acum %s luni' },
    w: { one: 'acum %s săpt.', few: 'acum %s săpt.', other: 'acum %s săpt.' },
    d: { one: 'acum %s zi', few: 'acum %s zile', other: 'acum %s de zile' },
    h: { one: 'acum %s h', few: 'acum %s h', other: 'acum %s h' },
    m: { one: 'acum %s min.', few: 'acum %s min.', other: 'acum %s min.' },
    s: { one: 'acum %s sec.', few: 'acum %s sec.', other: 'acum %s sec.' },
  },
  future: {
    y: { one: 'peste %s an', few: 'peste %s ani', other: 'peste %s de ani' },
    M: { one: 'peste %s lună', few: 'peste %s luni', other: 'peste %s luni' },
    w: { one: 'peste %s săpt.', few: 'peste %s săpt.', other: 'peste %s săpt.' },
    d: { one: 'peste %s zi', few: 'peste %s zile', other: 'peste %s de zile' },
    h: { one: 'peste %s h', few: 'peste %s h', other: 'peste %s h' },
    m: { one: 'peste %s min.', few: 'peste %s min.', other: 'peste %s min.' },
    s: { one: 'peste %s sec.', few: 'peste %s sec.', other: 'peste %s sec.' },
  },
  abbr: {
    y: { one: '%s an', few: '%s ani', other: '%s de ani' },
    M: { one: '%s lună', few: '%s luni', other: '%s de luni' },
    w: { one: '%s săptămână', few: '%s săptămâni', other: '%s de săptămâni' },
    d: { one: '%s zi', few: '%s zile', other: '%s de zile' },
    h: { one: '%s oră', few: '%s ore', other: '%s de ore' },
    m: { one: '%s minut', few: '%s minute', other: '%s de minute' },
    s: { one: '%s secundă', few: '%s secunde', other: '%s de secunde' },
  },
  justNow: 'chiar acum',
  yesterday: 'Ieri',
  today: 'Azi',
  tomorrow: 'Mâine',
  weekStart: 1,
};
const localeName: LocaleName = 'ro';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  meridiem: (): string => '',
};
